<div>
    <div [formGroup]="taggedItemForm" *ngIf="taggedItemForm">
        <div class="modal-header position-relative">
            <div class="row w-100 mt-4">
                <div class="col-md-12 text-start">
                    <div class="activity_title_wrapper d-flex align-items-center justify-content-start w-100">
                        <span class="activity_title">Instance Name </span>
                        <span class="section-data">{{ instanceName }}</span>
                        <span class="activity_title">Asset Type</span>
                        <span class="section-data">{{ assetTypeName }}</span>
                        <ng-container *ngIf="Tagged; item">
                            <span class="activity_title">Tagged Item</span>
                            <span class="section-data">{{ taggedItem?.name }}</span>
                        </ng-container>
                    </div>
                </div>

                <a href="javascript:void(0)" (click)="closeClick()">
                    <i class="flaticon2-cross close-icon"></i>

                </a>
            </div>
        </div>
        <div class="modal-body output-lable">
            <div class="row">
                <div class="col-md-12">
                    <div class="col-md-12">
                        <div class="activity_details">
                            <div class="row">
                                <div class="col-md-12 d-flex justify-content-start mt-3">
                                    <div class="col-md-4 d-flex align-items-center">
                                        <h3><span>Name</span></h3>
                                    </div>
                                    <div class="col-md-8">
                                        <mat-form-field class="example-full-width custom-text-field"
                                            [floatLabel]="'never'">
                                            <input type="text" matInput placeholder="Name" formControlName="name"
                                                name="ItemName" [readonly]="taggedItem?.name && !isCustom" />
                                        </mat-form-field>
                                        <mat-error *ngIf="taggedItemForm.get('name').hasError('forbiddenName')">
                                            Custom tagged item name must be unique.
                                        </mat-error>
                                    </div>
                                </div>
                                <div class="col-md-12 d-flex justify-content-start mt-3">
                                    <div class="col-md-4 d-flex align-items-center">
                                        <h3><span>Description</span></h3>
                                    </div>
                                    <div class="col-md-8">
                                        <mat-form-field class="example-full-width custom-text-field"
                                            [floatLabel]="'never'">
                                            <input type="text" matInput placeholder="Description"
                                                formControlName="description" name="taggedItemDescription" />
                                        </mat-form-field>
                                    </div>
                                </div>

                                <div class="col-md-12 d-flex justify-content-start mt-3">
                                    <div class="col-md-4 d-flex align-items-center">
                                        <h3><span>Can Allocate to Drawing</span></h3>
                                    </div>
                                    <div class="col-md-8">
                                        <mat-checkbox class="checkbox-wrap" formControlName="canallocate"
                                            name="canAllocate" [checked]="this.taggedItem?.canAllocate"
                                            [id]="canAllocate" (change)="canAllocatechange($event)"></mat-checkbox>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="schema_defination">
                        <h4>Latest Schema Definition</h4>
                        <button *ngIf="taggedItem?.schemaVersions" class="btn primary-ebtn" #tooltip="matTooltip"
                            [disabled]="taggedItem?.schemaRevision || taggedItem?.schemaVersions?.length >= 50 || isVersionAdd || !isAllowEdit"
                            matTooltip="Add New Schema" (click)="addNewVersion()">
                            <i class="fa fa-plus" aria-hidden="true"></i>
                        </button>
                        <mat-accordion>
                            <mat-expansion-panel *ngFor="let schema of displayVersionList; let i = index">
                                <mat-expansion-panel-header>
                                    <mat-panel-title style="width: 100%">
                                        Version {{ schema.version }}<span *ngIf="schema?.schemaVersionId == null"
                                            class="text-danger">*</span>
                                    </mat-panel-title>
                                    <mat-panel-description>
                                        <!-- <mat-icon><a href="javascript:void(0)">insert_drive_file</a></mat-icon>
                    <mat-icon><a href="javascript:void(0)">clear</a></mat-icon> -->
                                    </mat-panel-description>
                                </mat-expansion-panel-header>
                                <div class="json-editor">
                                    <json-editor #editor [options]="getJsonEditorOptions(schema)"
                                        [data]="getSchemaData(schema?.schemaVersionId)"></json-editor>
                                </div>
                                <div class="error-message" *ngIf="!schema?.schemaVersionId">{{
                                    taggedItemForm?.errors?.isNamePrimaryTwice }}</div>
                            </mat-expansion-panel>
                        </mat-accordion>
                        <mat-paginator [length]="currentPageItemLength" *ngIf="taggedItemVersionList?.length > 4"
                            [pageSize]="pageSize" (page)="pageEvent = getPaginationData($event)" #paginator>
                        </mat-paginator>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button href="javascript:void()" type="button" (click)="ngbActiveModal.close(false)"
                class="btn secondary-ebtn mr-3">Cancel</button>

            <button type="submit" class="btn primary-ebtn"
                [disabled]="!(taggedItemForm.valid && taggedItemForm.dirty) && isSchemaValid()"
                (click)="saveTaggedItemData()">
                Save
            </button>
        </div>
    </div>
</div>